import { formatDate } from './dateFormat';

/**
 * Calendar dates as the user's own clock sees them, as YYYY-MM-DD for date inputs and the API. Never use
 * toISOString() for this: it gives the UTC date, which is tomorrow in the Americas in the evening, and yesterday's date
 * for a local midnight in India.
 */
export function localISODate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today's date, YYYY-MM-DD, in the user's time zone. */
export const todayISO = () => localISODate(new Date());

/** A YYYY-MM-DD date moved by {@code days} (negative for earlier). */
export function addDaysISO(iso, days) {
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  return localISODate(new Date(y, m - 1, d + days));
}

/**
 * A YYYY-MM-DD date for display, read as that calendar day (new Date('2026-10-12') would be midnight UTC, which is the
 * 11th in the Americas).
 */
export function showDate(iso) {
  return formatDate(iso);
}
